import { render } from "./BigdataAnalytics.vue?vue&type=template&id=2cbea103"
import script from "./BigdataAnalytics.vue?vue&type=script&lang=js"
export * from "./BigdataAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__